import {AbstractControl, ValidatorFn} from '@angular/forms';
import {MultivalueDialogResult} from '../multivalue-dialog/multivalue-dialog-result';

export function multivalueRequired(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} => {
    if (
      control.value == null ||
      (Array.isArray(control.value) && control.value.length === 0) ||
      (control.value instanceof MultivalueDialogResult &&
        (control.value.Changes == null || control.value.Changes.length === 0))
    ) {
      return {required: {value: null}};
    } else {
      return null;
    }
  };
}
